import axios from 'axios';
import getbackendUrl from './getBackendUrl';
import { decode as decodeJwt } from 'jsonwebtoken';
import Cookies from 'universal-cookie';
import { get } from 'lodash-es';
import { login } from '../store';

async function refreshTokens(refreshToken, userSub) {
  const tokens = await axios
    .post(`${getbackendUrl()}/renewTokenWithoutIdToken`, {
      sub: userSub,
      refreshToken,
    })
    .then((res) => res.data);

  return tokens;
}

export default async function getFreshTokens(jpIdToken, refreshToken) {
  if (jpIdToken) {
    const decoded = decodeJwt(jpIdToken);

    if (decoded.exp * 1000 <= Date.now() && refreshToken) {
      try {
        const newTokens = await refreshTokens(refreshToken, decoded.sub);

        //Set cookies
        const cookies = new Cookies();
        cookies.remove('jp_idtoken');
        cookies.remove('jp_accesstoken');

        cookies.set('jp_idtoken', get(newTokens, 'idToken'), {
          path: '/',
        });
        cookies.set('jp_accesstoken', get(newTokens, 'accessToken'), {
          path: '/',
        });

        //Set state
        login(decodeJwt(get(newTokens, 'idToken')));
        return get(newTokens, 'idToken');
      } catch (error) {
        console.log(error);
        console.log('Unable to refresh tokens');
      }
    }
  }
  return jpIdToken;
}
